// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SpTicketModel } from '../interfaces/sp-ticket-model';
import { LocalizedDatePipe } from '../../shared/pipes/localizedDate.pipe';
import { ClipboardService } from '../../shared/services/clipboard.service';

@Component({
  standalone: true,
  imports: [TranslateModule, LocalizedDatePipe, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-service-tickets-table-mobile',
  templateUrl: './service-tickets-table-mobile.component.html',
  styleUrl: './service-tickets-table-mobile.component.scss',
})
export class ServiceTicketsTableMobileComponent {
  @Input({ required: true }) tickets: SpTicketModel[] = [];

  protected readonly UNKNOWN = 'Unknown';
  protected readonly clipboardService = inject(ClipboardService);
}
